import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { MANUAL_REGISTRATION_APPROVAL, MANUAL_REGISTRATION_APPROVAL_SUCCESS, MANUAL_REGISTRATION_APPROVAL_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* manualRegistrationApproval({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const { approval_id } = payload.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/user-registration`,
      method: 'POST',
      params: payload.data,
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200 || response.status === 201) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: MANUAL_REGISTRATION_APPROVAL_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: MANUAL_REGISTRATION_APPROVAL_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: MANUAL_REGISTRATION_APPROVAL_ERROR, payload: error });
  }
}

export function* watchmanualRegistrationApproval() {
  yield takeEvery(MANUAL_REGISTRATION_APPROVAL, manualRegistrationApproval);
}

function* manualRegistrationApprovalSaga() {
  yield all([fork(watchmanualRegistrationApproval)]);
}

export default manualRegistrationApprovalSaga;
